import { render, staticRenderFns } from "./Retrieve.vue?vue&type=template&id=bc4ca2bc&scoped=true&"
import script from "./Retrieve.vue?vue&type=script&lang=js&"
export * from "./Retrieve.vue?vue&type=script&lang=js&"
import style0 from "./Retrieve.vue?vue&type=style&index=0&id=bc4ca2bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4ca2bc",
  null
  
)

export default component.exports